import { Word, LocalAuthority, MotDto } from "../../model"
import { getBaseHeader } from "./utils"
import { apiBaseUrl } from "./config"
import { ErrorMessages, defaultErrorMessages, genericFetch } from "./common-service"
import { createWordRequestBody,createPolitiqueRequestBody, createFileUploadRequestBody } from "./factory";
import ApiError, { ApiErrorCode } from "../../error/api-error";

const LOCALAUTHORITIES = 'localauthorities'
const LOCALAUTHORITY = 'localautority'
const GLOSSARY = 'glossary'
const POLITIQUE = "political-approach"

export function createWord(localAuthority: LocalAuthority, word: Word): Promise<Word> {
	const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.id}/${GLOSSARY}`
	const init: RequestInit = {
		body: JSON.stringify(createWordRequestBody(word)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}

	return genericFetch<Word>(url, init)
}

export function createPolitique(localAuthority: LocalAuthority, politicalApproach: Word): Promise<Word> {
	const url = `${apiBaseUrl}/${LOCALAUTHORITY}/${localAuthority.id}/${POLITIQUE}`
	const init: RequestInit = {
		body: JSON.stringify(createPolitiqueRequestBody(politicalApproach)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}

	return genericFetch<Word>(url, init)
}

export function deleteWord(wordId: number, localAuthority: LocalAuthority): Promise<void> {
	const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.id}/${GLOSSARY}/${wordId}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}

	return genericFetch<void>(url, init)
}

export function deleteApproch(Id: number, localAuthority: LocalAuthority): Promise<void> {
	const url = `${apiBaseUrl}/${LOCALAUTHORITY}/${localAuthority.id}/${POLITIQUE}/${Id}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}

	return genericFetch<void>(url, init)
}

export function updateWord(word: Word, localAuthority: LocalAuthority): Promise<Word> {
	const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.id}/${GLOSSARY}/${word.id}`
	const init: RequestInit = {
		body: JSON.stringify(createWordRequestBody(word)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch<Word>(url, init)
}

export function updateApproch(politicalApproach: Word, localAuthority: LocalAuthority): Promise<Word> {
	const url = `${apiBaseUrl}/${LOCALAUTHORITY}/${localAuthority.id}/${POLITIQUE}/${politicalApproach.id}`
	const init: RequestInit = {
		body: JSON.stringify(createPolitiqueRequestBody(politicalApproach)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch<Word>(url, init)
}

export function getWordsByGabarit(gabarit:string){
	return genericFetch<MotDto[]>(`${apiBaseUrl}/${LOCALAUTHORITIES}/${GLOSSARY}/gabarit/${gabarit}/words`, {headers: getBaseHeader()});
}

export function getNumberOfWordsByGabarit(gabarit:string){
	return genericFetch<number>(`${apiBaseUrl}/${LOCALAUTHORITIES}/${GLOSSARY}/gabarit/${gabarit}/count`, {headers: getBaseHeader()});
}

export function importGlossary(file:File,gabarit:string): Promise<string> {
	const formData = new FormData();
	formData.append('file',file)
	const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${GLOSSARY}/upload-csv?gabarit=${gabarit}`
	const init: RequestInit = {
		body: formData,
		headers: {
			...getBaseHeader(),
		},
		method: "POST"
	}

	return genericFetch<string>(url, init)
}

export function exportGlossary(gabarit:string){	
	const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${GLOSSARY}/gabarit/${gabarit}/export`
	const init: RequestInit = {headers: {...getBaseHeader()}}
	return fetch(url, init)
}


// WEBPACK FOOTER //
// ./src/service/sfp/word-service.ts